import { createApp } from "./main";
import App from "./App.vue"

createApp(App).$mount("#app");
